import React from 'react'

function StatsCard({ label, value, icon, subValue, subLabel }) {
  return (
    <div className="admin-stats-card">
      <div className="admin-stats-icon">{icon}</div>
      <div className="admin-stats-value">{value != null ? value.toLocaleString() : '—'}</div>
      <div className="admin-stats-label">{label}</div>
      {subValue != null && (
        <div className="admin-stats-sub">
          <span className="admin-stats-sub-value">{subValue.toLocaleString()}</span>
          <span className="admin-stats-sub-label">{subLabel}</span>
        </div>
      )}
    </div>
  )
}

export default StatsCard
